import { render, staticRenderFns } from "./paymentNewDiscounts.vue?vue&type=template&id=7c19564b&scoped=true"
import script from "./paymentNewDiscounts.vue?vue&type=script&lang=ts"
export * from "./paymentNewDiscounts.vue?vue&type=script&lang=ts"
import style0 from "./paymentNewDiscounts.vue?vue&type=style&index=0&id=7c19564b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c19564b",
  null
  
)

export default component.exports